import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders } from "@angular/common/http";
//import { Plant } from '@app/_models/Plant';
import { environment } from '../../environments/environment';
import { OrganizationUserRole } from '../_models/User';
//import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  private activeOrganizationSubject: BehaviorSubject<Organization>;
  public activeOrganization: Observable<Organization>;


  constructor(private fb: FormBuilder, private http: HttpClient) { 
    this.activeOrganizationSubject = new BehaviorSubject<Organization>(JSON.parse(localStorage.getItem('currentOrganizaiton')));
    this.activeOrganization = this.activeOrganizationSubject.asObservable();

  }

  /*
  public ActiveOrganizationValue() : Organization {
    return this.activeOrganizationSubject.value;
  }

  public updateCurrenctOrganizationValue(organization: Organization) {
    console.log('Sätter ny aktiv organisation');
    console.log(organization);
    localStorage.setItem('currentOrganizaiton', JSON.stringify(organization));
    this.activeOrganizationSubject.next(organization);

    // todo: Måste detta rensas när man loggar ut?
  }
  */
  public get ActiveOrganization() : Organization {
    if (!this.activeOrganization) {
      console.log('Active org is null?');
      console.log(this.activeOrganizationSubject.value);
      return undefined;
    }
    else {
      console.log('Active org found');
      //console.log(this.activeOrganization);
      console.log(this.activeOrganizationSubject.value);
    }

    return this.activeOrganizationSubject.value;
  }

  public set ActiveOrganization(organization: Organization) {
    console.log('Sätter ny aktiv organisation');
    console.log(organization);
    localStorage.setItem('currentOrganizaiton', JSON.stringify(organization));
    this.activeOrganizationSubject.next(organization);

    // todo: Måste detta rensas när man loggar ut?
  }

  list() {
    return this.http.get(`${environment.apiUrl}/organization/`);
  }

  info() {
    return this.http.get(`${environment.apiUrl}/organization/${this.activeOrganizationSubject.getValue().id}` );
  }

  users() {
    return this.http.get(`${environment.apiUrl}/user/ForOrganization/${this.activeOrganizationSubject.getValue().id}`);
  }

  plants() {
    return this.http.get(`${environment.apiUrl}/plant/ForOrganization/${this.activeOrganizationSubject.getValue().id}`);
  }

  plantInfo(plantId) {
    return this.http.get(`${environment.apiUrl}/plant/${plantId}`);
  }

  updatePlant(plant) {
    return this.http.put(`${environment.apiUrl}/plant/`, plant);
  }

  addWorkTypeToPlant(plantId, workTypeId) {
    return this.http.post(`${environment.apiUrl}/plant/${plantId}/AddWorkType/${workTypeId}`, { Id: this.activeOrganizationSubject.getValue().id});
  }

  deleteWorkTypeFromPlant(organizationId, plantId, workTypeId) {
    return this.http.delete(`${environment.apiUrl}/plant/${this.activeOrganizationSubject.getValue().id}/${plantId}/DeleteWorkType/${workTypeId}`);
  }
}

export class Organization {
  name: string;
  id: number;
  lineOfBusinessId: number;
  roleCodes: string[];
  roles: string[];
  organizationUserRoles: OrganizationUserRole[]; 
}
